import React from 'react';
import { useHistory, useLocation } from 'react-router';
import useAuth from '../../hooks/useAuth';
import './Login.css'
import google from '../../images/google.png'

const Login = () => {
    const { signInUsingGoogle } = useAuth()

    const location = useLocation();
    const history = useHistory();
    const redirect_uri = location.state?.from || '/home';
    const handleGoogleSignIn = () => {
        signInUsingGoogle()
            .then((result) => {
                history.push(redirect_uri)
            })
    }

    return (
        <div>
            <div className="mt-5 pt-5 ">
                <div className=" w-100 w-lg-25 py-5 mx-auto">
                    <h2 style={{color:'#4285f4'}} className="mb-3">Login With</h2>
                    <div onClick={handleGoogleSignIn}>
                        <img style={{width:'100px',cursor:'pointer',border:'1px solid black'}} src={google} alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;